import TraderMode from '../components/pages/TraderMode/TraderModePage.vue'
import PopupWindowVideoTrader from '../components/pages/PopupWindowVideoTrader.vue'

export default [
  {
    path: '/trader/detail/:translationId',
    name: 'trader-mode',
    props: true,
    component: TraderMode,
    meta: {
      sideMenuDisabled: true
    }
  },
  {
    path: '/trader/video',
    name: 'trader-video',
    props: true,
    component: PopupWindowVideoTrader,
    meta: {
      sideMenuDisabled: true
    }
  }

]
